import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

import { getToken } from "./services/user";

const fallbackLng = ["en"];
const availableLanguages = ["en", "de", "fr", "cz"];

let token = getToken();

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    load: "languageOnly",
    fallbackLng: fallbackLng,
    preload: ["en", "de", "fr", "cz"],
    detection: {
      checkWhitelist: true,
    },
    returnEmptyString: false,
    debug: false,
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      bindI18n: 'loaded',
    },
    saveMissing: false,
    //saveMissingTo: "current",
    backend: {
      loadPath: process.env.REACT_APP_BASE_URL + "/api/translations?lng={{lng}}",
      customHeaders: () => ({
        Authorization: `Bearer ${token}`
      })
    },
  });

export default i18n;
